import r from"./isFunction.js";import t from"./isLength.js";var n=r,o=t;var i=function(r){return null!=r&&o(r.length)&&!n(r)};export{i as default};
//# sourceMappingURL=isArrayLike.js.map
